import React from 'react';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useText from '@hooks/use-text';

interface BackButtonProps {
    onClick: () => void;
}

const BackButton = ({ onClick }: BackButtonProps) => {
    const text = useText();

    return (
        <LinkButton size="large" icon={IconTypes.PIL_VENSTRE} onClick={onClick}>
            {text.formBack}
        </LinkButton>
    );
};

export default BackButton;
